<div class="how-it-works-area bg-mandish pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span class="sub-title" i18n>Want to Publish Your Article?</span>
            <h2 i18n>How to Publish?</h2>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-work-process mb-30">
                    <div class="icon">
                        <i class='bx bx-pen'></i>
                    </div>
                    <h3 i18n>Write Your Article</h3>
                    <p i18n>
                        Write your article in a word(doc), maximam tow pages.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-work-process mb-30">
                    <div class="icon">
                        <i class='bx bx-file'></i>
                    </div>
                    <h3 i18n>Convert it to PDF</h3>
                    <p i18n>
                        Now convert your written article to pdf format. 
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="single-work-process mb-30">
                    <div class="icon">
                        <i class='bx bx-upload'></i>
                    </div>
                    <h3 i18n>Send it To Us</h3>
                    <p i18n>Now everything is ready, just send your pdf file to the Email given in the contact</p>
                </div>
            </div>
        </div>
    </div>
</div>